var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNailPolish1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97302 3C5.97302 2.44772 6.43279 2 6.99995 2C7.56711 2 8.02688 2.44772 8.02688 3V8H5.97302V3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94614 10V12H4.02703C3.41947 12 2.94474 12.5108 3.0052 13.0995L3.82674 21.0995C3.87924 21.6107 4.32098 22 4.84857 22H9.15143C9.67901 22 10.1208 21.6107 10.1733 21.0995L10.9948 13.0995C11.0553 12.5108 10.5805 12 9.97297 12H9.05386V10C9.05386 9.44772 8.60614 9 8.05386 9H5.94614C5.39386 9 4.94614 9.44772 4.94614 10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8977 5.94128C13.9293 5.41272 14.3737 5 14.9113 5H19.0887C19.6263 5 20.0707 5.41272 20.1023 5.94128L20.6583 15.25H13.3417L13.8977 5.94128Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2521 16.75H20.7479L20.9982 20.9413C21.0325 21.5157 20.5688 22 19.9846 22H14.0154C13.4312 22 12.9675 21.5157 13.0018 20.9413L13.2521 16.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNailPolish1);
export default __webpack_public_path__ + "static/media/nail-polish-1.e078eecde0ddd07db92b7eba7e0f26c8.svg";
export { ForwardRef as ReactComponent };